import { ContactPageData } from "@/types";

export const contactPageData: ContactPageData = {
    title: "Get in Touch",
    heroImage: {
        src: "/images/banner.jpg",
        alt: "Underwater ocean exploration",
    },
    enquiries: {
        title: "For Enquiries",
        description: "For sales, service, and training-related enquiries, you can write to us at",
        contacts: [
            {
                title: "Sales",
                email: "sales@thepurpleoctopus.in",
            },
            {
                title: "Service Bench",
                email: "service@thepurpleoctopus.in",
            },
            {
                title: "Military/Training",
                email: "military@thepurpleoctopus.in",
            },
        ],
    },
    serviceLocation: {
        title: "Service Location",
        description: "Our in-house, certified technicians and instructors to service the equipment we supply across three different locations.",
        locations: [
            {
                id: "mumbai",
                name: "Mumbai",
                address: "Gala No 11, 1st Floor, Bldg No :- A1, Gami Industrial Park, Plot No. C-39/A, S Central Rd, MIDC Industrial Area, Pawne, Navi Mumbai, Maharashtra 400703, India",
                phone: "+91 98675 36990",
                email: "service@thepurpleoctopus.in",
                mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3824.360651716642!2d73.0277985!3d19.091938799999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c0d6e6b81365%3A0xb10088c4b9229dbb!2sThe%20Purple%20Octopus!5e1!3m2!1sen!2sin!4v1793080892627!5m2!1sen!2sin",
                brands: [
                    "APEKS",
                    "Aqualung",
                    "Aropec",
                    "BARE",
                    "Coltri",
                    "Delair Marine",
                    "Klepper",
                    "Mares",
                    "OCEANREEF",
                    "Orcatorch",
                    "rEvo",
                    "SEACRAFT",
                    "Seareq",
                    "Shark Marine Technologies Inc.",
                    "Shearwater",
                    "SHM",
                    "Sonardyne",
                    "SOS Group",
                    "Tusa",
                ],
                equipment: [
                    "Closer Circuit Rebreather Diving Set",
                    "Communication System",
                    "Compressor",
                    "Dive Computer",
                    "Diver Locator System",
                    "Diver Propulsion Vehicle",
                    "Diving Accessories",
                    "Dry Suits",
                    "Full Face Masks",
                    "Kayaks",
                    "Open Circuit Scuba",
                    "Portable Hyperbaric Chamber",
                    "Rigid Inflatable Boats",
                    "Semi Dry Suit",
                    "Underwater Navigation System",
                    "Underwater ROV",
                ],
            },
            {
                id: "goa",
                name: "Goa",
                address: "Aaron Fernandes, C/O Rosie George, 1/42-B George Dale, Gaura Vaddo. Behind Tarcar Ice Factory and Mario Miranda Gallery. Calangute, Goa 403516, India",
                phone: "+91 98675 36990",
                email: "service@thepurpleoctopus.in",
                mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d487.4003064999396!2d73.7664495!3d15.530457!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc1e917e5e607%3A0x4a557f6228ff4be!2sGeorgedale%20Guest%20House!5e1!3m2!1sen!2sin!4v1793080964759!5m2!1sen!2sin",
                brands: [
                    "APEKS",
                    "Aqualung",
                    "Mares",
                    "Tusa",
                ],
                equipment: [
                    "Dive Computer",
                    "Diving Accessories",
                    "Open Circuit Scuba",
                ],
            },
            {
                id: "havelock-island",
                name: "Havelock Island",
                address: "DIVEIndia, Beach No.5, White Sand Beach Resort, Swaraj Dweep, Govind Nagar, Havelock Island, Andaman and Nicobar Islands 744211, India",
                phone: "+91 98675 36990",
                email: "service@thepurpleoctopus.in",
                mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3958.109447008083!2d93.00283789999999!3d12.028487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3088d36c1abcd12d%3A0xb525d30287755ce1!2sDIVEIndia!5e1!3m2!1sen!2sin!4v1793081024957!5m2!1sen!2sin",
                brands: [
                    "APEKS",
                    "Aqualung",
                    "Coltri",
                    "Mares",
                    "rEvo",
                    "SEACRAFT",
                    "Tusa",
                ],
                equipment: [
                    "Closer Circuit Rebreather Diving Set",
                    "Compressor",
                    "Dive Computer",
                    "Diver Propulsion Vehicle",
                    "Diving Accessories",
                    "Open Circuit Scuba",
                ],
            },
        ],
    },
    officeLocation: {
        badge: "Headquarters",
        title: "Headquarters",
        subtitle: "Headquarters",
        address: "Gala No 11, 1st Floor, Bldg No :- A1, Gami Industrial Park, Plot No. C-39/A, S Central Rd, MIDC Industrial Area, Pawne, Navi Mumbai, Maharashtra 400703, India",
        phone: "+91 99207 63671",
        whatsapp: "+91 99207 63671",
        email: "online@thepurpleoctopus.in",
        mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3824.360651716642!2d73.0277985!3d19.091938799999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c0d6e6b81365%3A0xb10088c4b9229dbb!2sThe%20Purple%20Octopus!5e1!3m2!1sen!2sin!4v1793080892627!5m2!1sen!2sin",
    },
};